<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <side-bar :background-color="sidebarBackground" short-title="WFIWS EMS" title="WFIWS EMS">
      <template slot="links">
        <sidebar-item :link="{
          name: 'Dashboard',
          icon: 'fa fa-tv text-primary',
          path: '/admin/dashboard',
        }" />
        <div class="dropdown-divider" v-if="giftaway_access"></div>
        <h6 class="ml-3 navbar-heading text-muted" v-if="giftaway_access">
          Giftaway
        </h6>
        <sidebar-item v-if="giftaway_access" :link="{
          name: 'Merchant List',
          icon: 'fa fa-store text-purple',
          path: '/admin/giftaway/merchants',
        }" />
        <sidebar-item v-if="giftaway_access" :link="{
          name: 'Redeem Transaction',
          icon: 'fa fa-tasks text-green',
          path: '/admin/giftaway/transaction',
        }" />
        <div class="dropdown-divider" v-if="prizeItem_access"></div>
        <h6 class="ml-3 navbar-heading text-muted" v-if="prizeItem_access">
          Prize Item
        </h6>
        <sidebar-item v-if="prizeItem_access" :link="{
          name: 'Prize Item Config',
          icon: 'ni ni-single-copy-04 text-red',
          path: '/admin/giftaway/PrizeItemConfig',
        }" />
        <sidebar-item v-if="prizeItem_access" :link="{
          name: 'Special Prize Condition Config',
          icon: 'ni ni-single-copy-04 text-red',
          path: '/admin/giftaway/SpecialPrizeConditionConfig',
        }" />
        <div class="dropdown-divider" v-if="globalPromo_access"></div>
        <h6 class="ml-3 navbar-heading text-muted" v-if="globalPromo_access">
          Global Promo Configuration
        </h6>
        <sidebar-item v-if="promo_config_access" :link="{
          name: 'Promo Config',
          icon: 'ni ni-single-copy-04 text-red',
          path: '/admin/giftaway/GlobalPromoConfig',
        }" />
        <sidebar-item v-if="rules_config_access" :link="{
          name: 'Rules Config',
          icon: 'ni ni-single-copy-04 text-red',
          path: '/admin/giftaway/GlobalPromoRules',
        }" />
        <sidebar-item v-if="trigger_config_access" :link="{
          name: 'Trigger Config',
          icon: 'ni ni-single-copy-04 text-red',
          path: '/admin/giftaway/GlobalPromoTrigger',
        }" />
        <sidebar-item v-if="flash_promo_config_access" :link="{
          name: 'Flash Promo Config',
          icon: 'ni ni-single-copy-04 text-red',
          path: '/admin/giftaway/FlashPromoConfigs',
        }" />
        <div class="dropdown-divider" v-if="raffle_access"></div>
        <h6 class="ml-3 navbar-heading text-muted" v-if="raffle_access">
          Raffle Configuration
        </h6>
        <sidebar-item v-if="raffle_access" :link="{
          name: 'Raffle Event',
          icon: 'ni ni-single-copy-04 text-red',
          path: '/admin/raffle/RaffleEvent',
        }" />
        <sidebar-item v-if="raffle_winner_access" :link="{
          name: 'Raffle Event Winner',
          icon: 'ni ni-single-copy-04 text-red',
          path: '/admin/raffle/RaffleEventWinner',
        }" />
        <div class="dropdown-divider" v-if="province_access"></div>
        <h6 class="ml-3 navbar-heading text-muted" v-if="province_access">
          Province City Configuration
        </h6>
        <sidebar-item v-if="province_access" :link="{
          name: 'Province City',
          icon: 'ni ni-single-copy-04 text-red',
          path: '/admin/provinceCity/ProvinceCity',
        }" />

        <div class="dropdown-divider" v-if="userTask_access"></div>
        <h6 class="ml-3 navbar-heading text-muted" v-if="userTask_access">
          User Task Configuration
        </h6>
        <sidebar-item v-if="userTask_access" :link="{
          name: 'User Task Config',
          icon: 'ni ni-single-copy-04 text-red',
          path: '/admin/userTask/UserTaskConfig',
        }" />
        <sidebar-item v-if="userTask_access" :link="{
          name: 'User Task Rules Config',
          icon: 'ni ni-single-copy-04 text-red',
          path: '/admin/userTask/UserTaskRulesConfig',
        }" />
        <sidebar-item v-if="userTask_access" :link="{
          name: 'User Task Reaction Config',
          icon: 'ni ni-single-copy-04 text-red',
          path: '/admin/userTask/UserTaskReactionConfig',
        }" />
        <sidebar-item v-if="userTask_access" :link="{
          name: 'User Task Response Config',
          icon: 'ni ni-single-copy-04 text-red',
          path: '/admin/userTask/UserTaskResponseConfig',
        }" />

        <div class="dropdown-divider" v-if="giftaway_access"></div>
        <h6 class="ml-3 navbar-heading text-muted" v-if="giftaway_access">
          Stream Configuration
        </h6>
        <sidebar-item v-if="giftaway_access" :link="{
          name: 'Stream Config',
          icon: 'ni ni-single-copy-04 text-red',
          path: '/admin/stream',
        }" />

        <div class="dropdown-divider" v-if="promoter_access"></div>
        <h6 class="ml-3 navbar-heading text-muted" v-if="promoter_access">
          Promoter Configuration
        </h6>
        <sidebar-item v-if="promoter_access" :link="{
          name: 'Promoter Config',
          icon: 'ni ni-single-copy-04 text-red',
          path: '/admin/giftaway/PromoterConfig',
        }" />
        <div class="dropdown-divider" v-if="game_configuration_access"></div>
        <h6 class="ml-3 navbar-heading text-muted" v-if="game_configuration_access">
          Game Configuration
        </h6>
        <sidebar-item v-if="game_configuration_access" :link="{
          name: 'Game Config',
          icon: 'ni ni-single-copy-04 text-red',
          path: '/admin/giftaway/GameConfiguration',
        }" />

        <div class="dropdown-divider" v-if="userIsAdmin"></div>
        <h6 class="ml-3 navbar-heading text-muted" v-if="userIsAdmin">
          Role Mapping Configuration
        </h6>
        <sidebar-item v-if="userIsAdmin" :link="{
          name: 'Role Mapping Config',
          icon: 'ni ni-single-copy-04 text-red',
          path: '/admin/giftaway/RoleMappingConfig',
        }" />

        <div class="dropdown-divider" v-if="locality_config_access"></div>
        <h6 class="ml-3 navbar-heading text-muted" v-if="locality_config_access">
          Locality Configuration
        </h6>
        <sidebar-item v-if="locality_config_access" :link="{
          name: 'Locality Config',
          icon: 'ni ni-single-copy-04 text-red',
          path: '/admin/giftaway/LocalityConfig',
        }" />
        <sidebar-item v-if="locality_config_mapping_access" :link="{
          name: 'Locality Mapping Config',
          icon: 'ni ni-single-copy-04 text-red',
          path: '/admin/giftaway/LocalityMappingConfig',
        }" />

        <div class="dropdown-divider" v-if="report_access"></div>
        <h6 class="ml-3 navbar-heading text-muted" v-if="report_access">
          Report
        </h6>
        <sidebar-item v-if="account_status_report_access" :link="{
          name: 'Account Status Report',
          icon: 'ni ni-single-copy-04 text-red',
          path: '/admin/giftaway/AccountStatusReport',
        }" />
        <sidebar-item v-if="justscan_report_access" :link="{
          name: 'Just Scan Registration Report',
          icon: 'ni ni-single-copy-04 text-red',
          path: '/admin/giftaway/JustScanReport',
        }" />
        <sidebar-item v-if="daily_login_report_access" :link="{
          name: 'Daily Login Report',
          icon: 'ni ni-single-copy-04 text-red',
          path: '/admin/giftaway/DailyLoginReport',
        }" />
        <sidebar-item v-if="game_leaderboard_report_access" :link="{
          name: 'Game Leaderboard Report',
          icon: 'ni ni-single-copy-04 text-red',
          path: '/admin/giftaway/GameLeaderboardReport',
        }" />
        <sidebar-item v-if="game_daily_play_report_access" :link="{
          name: 'Game Daily Play Report',
          icon: 'ni ni-single-copy-04 text-red',
          path: '/admin/giftaway/GameDailyPlayReport',
        }" />
        <sidebar-item v-if="las_donation_report_access" :link="{
          name: 'LAS Donation Report',
          icon: 'ni ni-single-copy-04 text-red',
          path: '/admin/giftaway/LASDonationReport',
        }" />
        <sidebar-item v-if="ems_tracking_upc_multiply_report" :link="{
          name: 'EMS Tracking UPC Multiply Report',
          icon: 'ni ni-single-copy-04 text-red',
          path: '/admin/giftaway/EMSTrackingUPCMultiplyReport',
        }" />
        <sidebar-item v-if="las_activity_reward_transaction_report" :link="{
          name: 'LAS Activity Reward Transaction Report',
          icon: 'ni ni-single-copy-04 text-red',
          path: '/admin/giftaway/LASActivityRewardTransactionReport',
        }" />
        <sidebar-item v-if="shipping_receipt_report_access" :link="{
          name: 'Shipping Receipt Report',
          icon: 'ni ni-single-copy-04 text-red',
          path: '/admin/giftaway/ShippingReceiptReport',
        }" />
        <sidebar-item v-if="ugc_artWork_contest_report_access" :link="{
          name: 'UGC Artwork Contest Report',
          icon: 'ni ni-single-copy-04 text-red',
          path: '/admin/giftaway/UGCArtworkContestReport',
        }" />
        <sidebar-item v-if="ugc_artWork_votes_report_access" :link="{
          name: 'UGC Artwork Votes Report',
          icon: 'ni ni-single-copy-04 text-red',
          path: '/admin/giftaway/UGCArtworkVotesReport',
        }" />
        <sidebar-item v-if="global_promo_transaction_report_access" :link="{
          name: 'Global Promo Transaction Report',
          icon: 'ni ni-single-copy-04 text-red',
          path: '/admin/giftaway/GlobalPromoTransactionReport',
        }" />
        <sidebar-item v-if="upc_transaction_report_access" :link="{
          name: 'UPC Transaction Report',
          icon: 'ni ni-single-copy-04 text-red',
          path: '/admin/giftaway/UPCTransactionReport',
        }" />
        <sidebar-item v-if="upc_classification_report_access" :link="{
          name: 'UPC LAS Classification Report',
          icon: 'ni ni-single-copy-04 text-red',
          path: '/admin/giftaway/UPCLASClassificationReport',
        }" />
        <sidebar-item v-if="affiliator_referral_code_report_access" :link="{
          name: 'Affiliator Referral Code Report',
          icon: 'ni ni-single-copy-04 text-red',
          path: '/admin/giftaway/AffiliatorReferralCodeReport',
        }" />
        <sidebar-item v-if="referral_users_report_access" :link="{
          name: 'Referral Users Report',
          icon: 'ni ni-single-copy-04 text-red',
          path: '/admin/giftaway/ReferralUsersReport',
        }" />
        <sidebar-item v-if="upc_consumer_block_report_access" :link="{
          name: 'UPC Consumer Block Report',
          icon: 'ni ni-single-copy-04 text-red',
          path: '/admin/giftaway/UPCConsumerBlockReport',
        }" />
        <sidebar-item v-if="scheduler_process_report_access" :link="{
          name: 'Scheduler Process Report',
          icon: 'ni ni-single-copy-04 text-red',
          path: '/admin/giftaway/SchedulerProcessReport',
        }" />
        <sidebar-item v-if="scheduler_reProcess_report_access" :link="{
          name: 'Scheduler Re Process Report',
          icon: 'ni ni-single-copy-04 text-red',
          path: '/admin/giftaway/SchedulerReProcessReport',
        }" />
        <sidebar-item v-if="auditTrail_api_report_access" :link="{
          name: 'Audit Trail API Report',
          icon: 'ni ni-single-copy-04 text-red',
          path: '/admin/giftaway/AuditTrailAPIReport',
        }" />
        <sidebar-item v-if="blockUser_api_report_access" :link="{
          name: 'Block User  API Report',
          icon: 'ni ni-single-copy-04 text-red',
          path: '/admin/giftaway/BlockUserApiReport',
        }" />
        <sidebar-item v-if="content_view_report_access" :link="{
          name: 'Content View Report',
          icon: 'ni ni-single-copy-04 text-red',
          path: '/admin/giftaway/ContentViewReport',
        }" />
        <sidebar-item v-if="chest_prize_report_access" :link="{
          name: 'Chest Prize Report',
          icon: 'ni ni-single-copy-04 text-red',
          path: '/admin/giftaway/ChestPrizeReport',
        }" />
        <sidebar-item v-if="consumer_raffle_report_access" :link="{
          name: 'Consumer Raffle Report',
          icon: 'ni ni-single-copy-04 text-red',
          path: '/admin/raffle/ConsumerRaffleReport',
        }" />
        <sidebar-item v-if="consumer_raffle_event_winner_report_access" :link="{
          name: 'Consumer Raffle Event Winner Report',
          icon: 'ni ni-single-copy-04 text-red',
          path: '/admin/raffle/ConsumerRaffleEventWinnerReport',
        }" />
        <sidebar-item v-if="consumer_raffle_special_report_access" :link="{
          name: 'Consumer Raffle Special Report',
          icon: 'ni ni-single-copy-04 text-red',
          path: '/admin/raffle/ConsumerRaffleSpecialReport',
        }" />
        <sidebar-item v-if="consumer_raffle_special_event_winner_report_access" :link="{
          name: 'Consumer Raffle Special Event Winner Report',
          icon: 'ni ni-single-copy-04 text-red',
          path: '/admin/raffle/ConsumerRaffleSpecialEventWinnerReport',
        }" />
        <sidebar-item v-if="usertask_transaction_report_access" :link="{
          name: 'UserTask Transaction Report',
          icon: 'ni ni-single-copy-04 text-red',
          path: '/admin/giftaway/UserTaskTransactionReport',
        }" />
        <sidebar-item v-if="usertask_reaction_transaction_report_access" :link="{
          name: 'UserTask Reaction Transaction Report',
          icon: 'ni ni-single-copy-04 text-red',
          path: '/admin/giftaway/UserTaskReactionTransactionReport',
        }" />
        <sidebar-item v-if="usertask_response_transaction_report_access" :link="{
          name: 'UserTask Response Transaction Report',
          icon: 'ni ni-single-copy-04 text-red',
          path: '/admin/giftaway/UserTaskResponseTransactionReport',
        }" />
        <sidebar-item v-if="access_log_report_access" :link="{
          name: 'Access Log Report',
          icon: 'ni ni-single-copy-04 text-red',
          path: '/admin/giftaway/AccessLogReport',
        }" />
        <sidebar-item v-if="veratad_failed_log_report_access" :link="{
          name: 'Veratad Failed Log Report',
          icon: 'ni ni-single-copy-04 text-red',
          path: '/admin/giftaway/VeratadFailedLogReport',
        }" />
        <sidebar-item v-if="acs_log_report_access" :link="{
          name: 'ACS Log Report',
          icon: 'ni ni-single-copy-04 text-red',
          path: '/admin/giftaway/ACSLogReport',
        }" />
        <sidebar-item v-if="registration_acs_status_report_access" :link="{
          name: 'Registration ACS Status Report',
          icon: 'ni ni-single-copy-04 text-red',
          path: '/admin/giftaway/RegistrationACSStatusReport',
        }" />
        <sidebar-item v-if="summarize_consumer_report_access" :link="{
          name: 'Summarize Consumer Report',
          icon: 'ni ni-single-copy-04 text-red',
          path: '/admin/giftaway/SummarizeConsumerReport',
        }" />
        <sidebar-item v-if="prize_adjustment_report_access" :link="{
          name: 'Prize Adjustment Report',
          icon: 'ni ni-single-copy-04 text-red',
          path: '/admin/giftaway/PrizeAdjustmentReport',
        }" />
        <sidebar-item v-if="rt_las_link_report_access" :link="{
          name: 'RT - LAS Link Report',
          icon: 'ni ni-single-copy-04 text-red',
          path: '/admin/giftaway/RtLasLinkReport',
        }" />
        <sidebar-item v-if="isms_code_data_report_access" :link="{
          name: 'ISMS Code Master Data Report',
          icon: 'ni ni-single-copy-04 text-red',
          path: '/admin/giftaway/ISMSCodeDataReport',
        }" />
        <div v-if="userIsAdmin" class="dropdown-divider"></div>
        <h6 v-if="userIsAdmin" class="ml-3 navbar-heading text-muted">
          Settings
        </h6>
        <sidebar-item v-if="userIsAdmin" :link="{
          name: 'Global Configuration',
          icon: 'ni ni-settings text-yellow',
          path: '/admin/config',
        }" />
      </template>
    </side-bar>
    <div class="main-content" :data="sidebarBackground">
      <dashboard-navbar></dashboard-navbar>

      <div @click="toggleSidebar">
        <fade-transition :duration="200" class="main" origin="center top" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </fade-transition>
        <modal :show.sync="isIdle" modal-classes="modal">
          <h4 slot="header" class="modal-title" id="modal-title-default">
            Session Expired - Force Logout
          </h4>
          <p>
            You have left this browser idle for 1 hour. Please re-login...
          </p>
        </modal>
        <content-footer v-if="!$route.meta.hideFooter"></content-footer>
      </div>
    </div>
  </div>
</template>
<script>
import DashboardNavbar from "./DashboardNavbar.vue";
import { Auth } from "aws-amplify"
import ContentFooter from "./ContentFooter.vue";
import { FadeTransition } from "vue2-transitions";
import router from "./../router";

export default {
  components: {
    DashboardNavbar,
    ContentFooter,
    FadeTransition,
  },
  data() {
    return {
      sidebarBackground: "vue", //vue|blue|orange|green|red|primary
    };
  },
  created() {
    window['getIdentity'] = async function () {
      const authSession = await Auth.currentSession();

      return {
        token_info: {
          id_token: authSession.getIdToken().getJwtToken(),
          access_token: authSession.getAccessToken().getJwtToken()
        }
      }
    }
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
  },
  computed: {
    userIsAdmin() {
      return this.$store.getters.isLoginUserAdmin;
    },
    userIsFortuneAdmin() {
      return this.$store.getters.isFortuneAdmin;
    },
    loginUser() {
      return this.$store.getters.loginUser;
    },
    userIsCheAdmin() {
      return this.$store.getters.isCheAdmin;
    },
    userIsGiftawayReaders() {
      return (
        this.$store.getters.isCheReader || this.$store.getters.isFortuneReader
      );
    },
    //#region menu access
    giftaway_access() {
      return this.userIsAdmin ||
        this.$store.getters.roleMappingData.some(object =>
          object.group.toLowerCase() === "giftaway"
        )
    },
    prizeItem_access() {
      return this.userIsAdmin ||
        this.$store.getters.roleMappingData.some(object =>
          object.group.toLowerCase() === "prizeitem" &&
          object.menu.toLowerCase() === "prizeitemconfig"
        )
    },
    globalPromo_access() {
      return this.userIsAdmin ||
        this.$store.getters.roleMappingData.some(object =>
          object.group.toLowerCase() === "globalpromoconfig"
        )
    },
    promo_config_access() {
      return this.userIsAdmin ||
        this.$store.getters.roleMappingData.some(object =>
          object.group.toLowerCase() === "globalpromoconfig" &&
          object.menu.toLowerCase() === "promoconfig"
        )
    },
    rules_config_access() {
      return this.userIsAdmin ||
        this.$store.getters.roleMappingData.some(object =>
          object.group.toLowerCase() === "globalpromoconfig" &&
          object.menu.toLowerCase() === "rulesconfig"
        )
    },
    trigger_config_access() {
      return this.userIsAdmin ||
        this.$store.getters.roleMappingData.some(object =>
          object.group.toLowerCase() === "globalpromoconfig" &&
          object.menu.toLowerCase() === "triggerconfig"
        )
    },
    flash_promo_config_access() {
      return this.userIsAdmin ||
        this.$store.getters.roleMappingData.some(object =>
          object.group.toLowerCase() === "globalpromoconfig" &&
          object.menu.toLowerCase() === "flashpromoconfig"
        )
    },
    raffle_access() {
      return this.userIsAdmin ||
        this.$store.getters.roleMappingData.some(object =>
          object.group.toLowerCase() === "raffleeventconfig" &&
          object.menu.toLowerCase() === "raffleevent"
        )
    },
    raffle_winner_access() {
      return this.userIsAdmin ||
        this.$store.getters.roleMappingData.some(object =>
          object.group.toLowerCase() === "raffleeventconfig" &&
          object.menu.toLowerCase() === "raffleeventwinner"
        )
    },
    province_access() {
      return this.userIsAdmin ||
        this.$store.getters.roleMappingData.some(object =>
          object.group.toLowerCase() === "provincecityconfig"
        )
    },
    locality_config_access() {
      return this.userIsAdmin ||
        this.$store.getters.roleMappingData.some(object =>
          object.group.toLowerCase() === "localityconfiguration" &&
          object.menu.toLowerCase() === "localityconfig"
        )
    },
    locality_config_mapping_access() {
      return this.userIsAdmin ||
        this.$store.getters.roleMappingData.some(object =>
          object.group.toLowerCase() === "localityconfiguration" &&
          object.menu.toLowerCase() === "localitymappingconfig"
        )
    },
    daily_login_report_access() {
      return this.userIsAdmin ||
        this.$store.getters.roleMappingData.some(object =>
          object.group.toLowerCase() === "report" &&
          object.menu.toLowerCase() === "dailyloginreport"
        )
    },
    game_leaderboard_report_access() {
      return this.userIsAdmin ||
        this.$store.getters.roleMappingData.some(object =>
          object.group.toLowerCase() === "report" &&
          object.menu.toLowerCase() === "gameleaderboardreport"
        )
    },
    game_daily_play_report_access() {
      return this.userIsAdmin ||
        this.$store.getters.roleMappingData.some(object =>
          object.group.toLowerCase() === "report" &&
          object.menu.toLowerCase() === "gamedailyplayreport"
        )
    },
    userTask_access() {
      return this.userIsAdmin ||
        this.$store.getters.roleMappingData.some(object =>
          object.group.toLowerCase() === "usertaskconfiguration"
        )
    },
    stream_access() {
      return this.userIsAdmin ||
        this.$store.getters.roleMappingData.some(object =>
          object.group.toLowerCase() === "streamconfig"
        )
    },
    promoter_access() {
      return this.userIsAdmin ||
        this.$store.getters.roleMappingData.some(object =>
          object.group.toLowerCase() === "promoterconfiguration"
        )
    },
    report_access() {
      return this.userIsAdmin ||
        this.$store.getters.roleMappingData.some(object =>
          object.group.toLowerCase() === "report"
        )
    },
    las_donation_report_access() {
      return this.userIsAdmin ||
        this.$store.getters.roleMappingData.some(object =>
          object.group.toLowerCase() === "report" &&
          object.menu.toLowerCase() === "lasdonationreport"
        )
    },
    ems_tracking_upc_multiply_report() {
      return this.userIsAdmin ||
        this.$store.getters.roleMappingData.some(object =>
          object.group.toLowerCase() === "report" &&
          object.menu.toLowerCase() === "emstrackingupcmultiplyreport"
        )
    },
    las_activity_reward_transaction_report() {
      return this.userIsAdmin ||
        this.$store.getters.roleMappingData.some(object =>
          object.group.toLowerCase() === "report" &&
          object.menu.toLowerCase() === "lasactivityrewardtransactionreport"
        )
    },
    shipping_receipt_report_access() {
      return this.userIsAdmin ||
        this.$store.getters.roleMappingData.some(object =>
          object.group.toLowerCase() === "report" &&
          object.menu.toLowerCase() === "shippingreceiptreport"
        )
    },
    ugc_artWork_contest_report_access() {
      return this.userIsAdmin ||
        this.$store.getters.roleMappingData.some(object =>
          object.group.toLowerCase() === "report" &&
          object.menu.toLowerCase() === "ugcartworkcontestreport"
        )
    },
    ugc_artWork_votes_report_access() {
      return this.userIsAdmin ||
        this.$store.getters.roleMappingData.some(object =>
          object.group.toLowerCase() === "report" &&
          object.menu.toLowerCase() === "ugcartworkvotesreport"
        )
    },
    global_promo_transaction_report_access() {
      return this.userIsAdmin ||
        this.$store.getters.roleMappingData.some(object =>
          object.group.toLowerCase() === "report" &&
          object.menu.toLowerCase() === "globalpromotransactionreport"
        )
    },
    upc_transaction_report_access() {
      return this.userIsAdmin ||
        this.$store.getters.roleMappingData.some(object =>
          object.group.toLowerCase() === "report" &&
          object.menu.toLowerCase() === "upctransactionreport"
        )
    },
    upc_classification_report_access() {
      return this.userIsAdmin ||
        this.$store.getters.roleMappingData.some(object =>
          object.group.toLowerCase() === "report" &&
          object.menu.toLowerCase() === "upclasclassificationreport"
        )
    },
    affiliator_referral_code_report_access() {
      return this.userIsAdmin ||
        this.$store.getters.roleMappingData.some(object =>
          object.group.toLowerCase() === "report" &&
          object.menu.toLowerCase() === "affiliatorreferralcodereport"
        )
    },
    referral_users_report_access() {
      return this.userIsAdmin ||
        this.$store.getters.roleMappingData.some(object =>
          object.group.toLowerCase() === "report" &&
          object.menu.toLowerCase() === "referralusersreport"
        )
    },
    upc_consumer_block_report_access() {
      return this.userIsAdmin ||
        this.$store.getters.roleMappingData.some(object =>
          object.group.toLowerCase() === "report" &&
          object.menu.toLowerCase() === "upcconsumerblockreport"
        )
    },
    scheduler_process_report_access() {
      return this.userIsAdmin ||
        this.$store.getters.roleMappingData.some(object =>
          object.group.toLowerCase() === "report" &&
          object.menu.toLowerCase() === "schedulerprocessreport"
        )
    },
    scheduler_reProcess_report_access() {
      return this.userIsAdmin ||
        this.$store.getters.roleMappingData.some(object =>
          object.group.toLowerCase() === "report" &&
          object.menu.toLowerCase() === "schedulerreprocessreport"
        )
    },
    auditTrail_api_report_access() {
      return this.userIsAdmin ||
        this.$store.getters.roleMappingData.some(object =>
          object.group.toLowerCase() === "report" &&
          object.menu.toLowerCase() === "audittrailapireport"
        )
    },
    blockUser_api_report_access() {
      return this.userIsAdmin ||
        this.$store.getters.roleMappingData.some(object =>
          object.group.toLowerCase() === "report" &&
          object.menu.toLowerCase() === "blockuserapireport"
        )
    },
    content_view_report_access() {
      return this.userIsAdmin ||
        this.$store.getters.roleMappingData.some(object =>
          object.group.toLowerCase() === "report" &&
          object.menu.toLowerCase() === "contentviewreport"
        )
    },
    account_status_report_access()
    {
      return this.userIsAdmin ||
        this.$store.getters.roleMappingData.some(object =>
          object.group.toLowerCase() === "report" &&
          object.menu.toLowerCase() === "accountstatusreport"
        )
    },   game_configuration_access()
    {
      return this.userIsAdmin ||
        this.$store.getters.roleMappingData.some(object =>
          object.group.toLowerCase() === "configuration" &&
          object.menu.toLowerCase() === "gameconfiguration"
        )
    },
    chest_prize_report_access() {
      return this.userIsAdmin ||
        this.$store.getters.roleMappingData.some(object =>
          object.group.toLowerCase() === "report" &&
          object.menu.toLowerCase() === "chestprizereport"
        )
    },
    justscan_report_access() {
      return this.userIsAdmin ||
        this.$store.getters.roleMappingData.some(object =>
          object.group.toLowerCase() === "report" &&
          object.menu.toLowerCase() === "justscanreport"
        )
    },
    consumer_raffle_report_access()
    {
      return this.userIsAdmin ||
        this.$store.getters.roleMappingData.some(object =>
          object.group.toLowerCase() === "report" &&
          object.menu.toLowerCase() === "consumerrafflereport"
        )
    },
    consumer_raffle_event_winner_report_access()
    {
      return this.userIsAdmin ||
        this.$store.getters.roleMappingData.some(object =>
          object.group.toLowerCase() === "report" &&
          object.menu.toLowerCase() === "consumerraffleeventwinnerreport"
        )
    },
    consumer_raffle_special_report_access()
    {
      return this.userIsAdmin ||
        this.$store.getters.roleMappingData.some(object =>
          object.group.toLowerCase() === "report" &&
          object.menu.toLowerCase() === "consumerrafflespecialreport"
        )
    },
    consumer_raffle_special_event_winner_report_access()
    {
      return this.userIsAdmin ||
        this.$store.getters.roleMappingData.some(object =>
          object.group.toLowerCase() === "report" &&
          object.menu.toLowerCase() === "consumerrafflespecialeventwinnerreport"
        )
    },
    usertask_transaction_report_access() {
      return this.userIsAdmin ||
        this.$store.getters.roleMappingData.some(object =>
          object.group.toLowerCase() === "report" &&
          object.menu.toLowerCase() === "usertasktransactionreport"
        )
    },
    usertask_reaction_transaction_report_access() {
      return this.userIsAdmin ||
        this.$store.getters.roleMappingData.some(object =>
          object.group.toLowerCase() === "report" &&
          object.menu.toLowerCase() === "usertaskreactiontransactionreport"
        )
    },
    usertask_response_transaction_report_access() {
      return this.userIsAdmin ||
        this.$store.getters.roleMappingData.some(object =>
          object.group.toLowerCase() === "report" &&
          object.menu.toLowerCase() === "usertaskresponsetransactionreport"
        )
    },
    acs_log_report_access() {
      return this.userIsAdmin ||
        this.$store.getters.roleMappingData.some(object =>
          object.group.toLowerCase() === "report" &&
          object.menu.toLowerCase() === "acslogreport"
        )
    },
    access_log_report_access() {
      return this.userIsAdmin ||
        this.$store.getters.roleMappingData.some(object =>
          object.group.toLowerCase() === "report" &&
          object.menu.toLowerCase() === "accesslogreport"
        )
    },
    veratad_failed_log_report_access() {
      return this.userIsAdmin ||
        this.$store.getters.roleMappingData.some(object =>
          object.group.toLowerCase() === "report" &&
          object.menu.toLowerCase() === "veratadfailedlogreport"
        )
    },
    registration_acs_status_report_access() {
      return this.userIsAdmin ||
        this.$store.getters.roleMappingData.some(object =>
          object.group.toLowerCase() === "report" &&
          object.menu.toLowerCase() === "registrationacsstatusreport"
        )
    },
    summarize_consumer_report_access() {
      return this.userIsAdmin ||
        this.$store.getters.roleMappingData.some(object =>
          object.group.toLowerCase() === "report" &&
          object.menu.toLowerCase() === "summarizeconsumerreport"
        )
    },
    prize_adjustment_report_access() {
      return this.userIsAdmin ||
        this.$store.getters.roleMappingData.some(object =>
          object.group.toLowerCase() === "report" &&
          object.menu.toLowerCase() === "prizeadjustmentreport"
        )
    },
    rt_las_link_report_access() {
      return this.userIsAdmin ||
        this.$store.getters.roleMappingData.some(object =>
          object.group.toLowerCase() === "report" &&
          object.menu.toLowerCase() === "rtlaslinkreport"
        )
    },
    isms_code_data_report_access() {
      return this.userIsAdmin ||
        this.$store.getters.roleMappingData.some(object =>
          object.group.toLowerCase() === "report" &&
          object.menu.toLowerCase() === "ismscodedatareport"
        )
    },
    
    //#endregion menu access
    isIdle() {
      return this.$store.state.idleVue.isIdle;
    }
  },
  watch: {
    isIdle: function (val) {
      if (val) {
        router.push({ name: "logout" });
      }
      console.log(val);
    },
  }
};
</script>
<style lang="scss">
.main {
  min-height: 700px;
}
</style>
